import { Button } from "@babackapp/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { t } from "i18next";
import { PropsWithChildren, useCallback } from "react";
import { useDeleteCarrierFromShop } from "@babackapp/private-api-client/client/use-delete-carrier-from-shop";
import { useCarriersContext } from "../../use-carriers-context";

export const DeleteCarrierTransportDialog = ({
  children,
  isOpen,
  setIsModalOpen,
  selectedCarrierID,
}: PropsWithChildren<{
  setIsModalOpen: (value: boolean) => void;
  closeForm: () => void;
  isOpen: boolean;
  selectedCarrierID: string;
}>) => {
  const { shop } = useCarriersContext();
  const closeForm = () => setIsModalOpen(false);
  const { mutate: deleteCarrierFromShop } = useDeleteCarrierFromShop(shop.id);
  const deleteCarrier = useCallback(() => {
    deleteCarrierFromShop({ carrierId: selectedCarrierID });
  }, [selectedCarrierID]);

  const onSubmit = () => {
    deleteCarrier();
    closeForm();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsModalOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle> {t("carrier.labelDelete")}</DialogTitle>
          <DialogDescription>{t("carrier.subLabelDelete")}</DialogDescription>
        </DialogHeader>
        <div className="flex justify-between mt-5 gap-4">
          <Button
            type="submit"
            variant="outline"
            onClick={closeForm}
            className="w-full"
          >
            {t("misc.cancel")}
          </Button>
          <Button
            type="submit"
            variant="default"
            className="w-full"
            onClick={onSubmit}
          >
            {t("misc.confirm")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
